<template>
  <div v-if="extraItem.extras('banner.display')" class="header-banner">
    <img class="header-banner-image" :src="extraItem.extras('banner.src')" />
  </div>
</template>

<script>
export default {
  name: "Banner",
  props: ["extras"]
};
</script>
